<template>
  <div class="application">
    <b-content-header :to="{name: 'ApartmentItem', params: {id: apartmentId, info: 'current'}}">
      <span uk-icon="icon: occupant-list; ratio: 1.5" class="shield" style="color: #fff7a8;"></span>
      <span class="content-header--title" v-text="`Помещение № ${apartmentNumber}`"></span>
    </b-content-header>
    <WrapperContent v-if="occupant">
      <div v-if="errorMessage" class="uk-alert-danger" uk-alert>
        <p>{{ errorMessage }}</p>
      </div>
      <Spinner :isLoading="isLoading">
        <table :key="'table' + keyIndex" class="uk-table">
          <tbody>
            <tr>
              <td class="info-left-col">Идентификационный номер (личный номер)</td>
              <td v-text="occupant.passport ? occupant.passport.toUpperCase() : '-'"></td>
            </tr>
            <tr>
              <td class="info-left-col">ФИО</td>
              <td v-text="`${occupant.surname} ${occupant.name} ${occupant.patronymic}`"></td>
            </tr>
            <tr>
              <td class="info-left-col">номер телефона</td>
              <td v-text="occupant.phone"></td>
            </tr>
            <tr>
              <td class="info-left-col">Email</td>
              <td v-text="occupant.email ? occupant.email : '-'"></td>
            </tr>
            <tr>
              <td class="info-left-col">статус</td>
              <td class="uk-flex uk-flex-middle">
                <span
                  v-if="occupant.connected"
                  uk-icon="icon: check; ratio: 0.8"
                  style="color: #0FB269"
                ></span>
                <span v-else uk-icon="icon: close; ratio: 0.8" style="color: #E31E24"></span>
                <span
                  class="uk-margin-small-left"
                  v-text="occupant.connected ? 'Подключен' : 'Не подключен'"
                ></span>
              </td>
            </tr>
            <tr>
              <td class="info-left-col">тип жильца</td>
              <td colspan="3">
                <div class="uk-flex radio-group uk-flex-wrap">
                  <b-radio
                    v-model="occupant.ownershipType"
                    value="OWNER"
                    name="typeOfTenant"
                    disabled
                  >
                    Собственник
                  </b-radio>
                  <b-radio
                    v-model="occupant.ownershipType"
                    value="REPRESENTATIVE"
                    name="typeOfTenant"
                    disabled
                  >
                    Представитель собственника
                  </b-radio>
                  <b-radio
                    v-model="occupant.ownershipType"
                    value="TENANT"
                    name="typeOfTenant"
                    disabled
                  >
                    Арендатор
                  </b-radio>
                </div>
              </td>
            </tr>
            <tr
              v-if="
                occupant.ownershipType === 'OWNER' || occupant.ownershipType === 'REPRESENTATIVE'
              "
            >
              <td class="info-left-col">Доля собственности</td>
              <td>
                <span v-text="occupant.ownershipShare ? occupant.ownershipShare : '-'"></span>
                <span style="margin-left: 4px">%</span>
              </td>
            </tr>
            <tr v-if="occupant.ownershipType === 'REPRESENTATIVE'">
              <td class="info-left-col">Номер документа</td>
              <td>
                <span v-text="occupant.document ? occupant.document : '-'"></span>
              </td>
            </tr>
            <tr>
              <td class="info-left-col">Примечание</td>
              <td>
                <span v-text="occupant.note"></span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="uk-flex uk-flex-center uk-margin-medium-top">
          <b-button name="Редактировать" @click="$modal.show('apartment-profile')" />
        </div>
        <div class="remove uk-flex uk-flex-middle">
          <div @click="$modal.show('apartment-confirm')">
            <span uk-icon="icon: close; ratio: 1"></span>
            <span class="uk-margin-small-left">Удалить жильца</span>
          </div>
        </div>
      </Spinner>
    </WrapperContent>
    <EditProfileFormDialog :tenant="occupant" :occupants="occupants" @update="updateData" />
    <b-confirm name="apartment-confirm" @confirm="deleteCard">
      <span slot="header">
        Вы уверены, что хотите удалить жильца из помещения № {{ apartmentNumber }}?
      </span>
    </b-confirm>
  </div>
</template>

<script>
import BContentHeader from '@/components/b-content-header'
import EditProfileFormDialog from './_dialogs/_edit-profile'
import {ownershipTypeAsString} from '@/views/variables/ownership_type'
import {showSuccess} from '@/common/utils/notification'

import {mapActions} from 'vuex'

export default {
  name: 'ItemInfo',
  components: {
    BContentHeader,
    EditProfileFormDialog
  },
  props: {
    apartmentId: {
      type: [Number, String],
      default: null
    }
  },
  data: () => ({
    errorMessage: '',
    occupants: [],
    occupant: null,
    keyIndex: 0,
    apartment: null,
    isLoading: false
  }),
  computed: {
    apartmentNumber() {
      return this.apartment !== null && this.apartment.apartmentNumber !== ''
        ? this.apartment.apartmentNumber
        : '-'
    }
  },
  methods: {
    ...mapActions({
      getApartmentCard: 'apartment/GET_APARTMENT_CARD',
      getApartmentOccupantInfo: 'apartment/GET_APARTMENT_OCCUPANT',
      deleteApartmentCard: 'apartment/DELETE_APARTMENT_CARD'
    }),
    fetchInfoOccupant() {
      this.isLoading = true
      this.getApartmentCard(this.apartmentId)
        .then(resp => {
          this.occupants = resp
          this.occupant = this.occupants.find(item => item.occupantId === +this.$route.params.id)
          this.isLoading = false
        })
        .catch(() => {
          this.occupants = null
          this.isLoading = false
        })

      this.getApartmentOccupantInfo(this.apartmentId)
        .then(resp => {
          this.apartment = resp
        })
        .catch(() => (this.apartment = null))
    },
    ownershipTypeAsString: ownershipTypeAsString,
    deleteCard() {
      this.deleteApartmentCard(this.occupant.id)
        .then(() => {
          showSuccess(ownershipTypeAsString(this.occupant.ownershipType) + ' успешно удален')
          this.$router.push({name: 'ApartmentItem', params: {id: this.apartmentId}})
        })
        .catch(err => {
          this.errorMessage = err
        })
    },
    updateData() {
      this.fetchInfoOccupant()
      this.errorMessage = ''
    }
  },
  mounted() {
    this.updateData()
  }
}
</script>
